import { useRef } from 'react'
import { useClientsAnalyticsState } from './clientsAnalyticsState'
import { ClientsDonutCard } from './ClientsDonutCard'
import { ClientsHeatmapCard } from './ClientsHeatmapCard'
import type { DashboardPeriodKey } from './types'

interface Props {
  periodKey: DashboardPeriodKey
  customFrom: string | null
  customTo: string | null
}

/**
 * Секция аналитики клиентской базы на дашборде админа.
 * Объединяет donut (по матрицам/категориям/сегментам/городам) и heatmap.
 * Состояние фильтров + режим — общее для обеих карточек, локальное,
 * не персистится. Селекция менеджеров — общая с таблицами /planning
 * (через users.gridSettings.planningSelection).
 */
export function ClientsAnalyticsSection({ periodKey, customFrom, customTo }: Props) {
  const state = useClientsAnalyticsState()
  const donutRef = useRef<HTMLDivElement>(null)

  return (
    <div className="space-y-4">
      <div ref={donutRef}>
        <ClientsDonutCard
          periodKey={periodKey}
          customFrom={customFrom}
          customTo={customTo}
          state={state}
        />
      </div>
      <ClientsHeatmapCard
        periodKey={periodKey}
        customFrom={customFrom}
        customTo={customTo}
        state={state}
        scrollTargetRef={donutRef}
      />
    </div>
  )
}
